import { useState } from "react";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import * as S from "./styles";
import KOGCollapse from "../../kogCollapse/kogCollapse";
import { supervisionAssignmentFilterRequest } from "@/main/models/request/supervisionAssignment";
import SearchBodyshop from "../searchBodyshop/searchBodyshop";
import { userIsAdmin, userIsInsurer } from "@/main/services/utilsUser";
import { KeyValue } from "@/main/models/common";
import { insurerApi } from "@/main/api";
import { supervisionAssignmentApi } from "@/main/api/supervisionAssignmentApi";
import { useUserReducer } from "@/main/store/user";
import { InsurerFilterRequest } from "@/main/models/request";
import RegisterSupervisorAssignment from "../registerSupervisorAssignment";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";

interface IsupervisorBodyshopSidebarProps {
	guidCompany: string;
	open: boolean;
	closeModal: (reset: boolean) => void;
}

function SupervisorBodyshopSidebar({ guidCompany, open, closeModal }: IsupervisorBodyshopSidebarProps) {
	//#region Consts
	const userReducer = useUserReducer();
	//#endregion

	//#region stats
	const [isLoading, setLoad] = useState<boolean>(false);
	const [dataGridInsurer, setDataGridInsurer] = useState<KeyValue[]>([]);
	const [dataGridBodyshop, setDataGridBodyshop] = useState<KeyValue[]>([]);
	const [totalItems, setTotalItems] = useState<number>(0);
	const [guidInsurer, setGuidInsurer] = useState<string>("");
	const [requestFilterForm, setFormFilters] = useState<supervisionAssignmentFilterRequest | null>(null);
	const [resetSearchTrigger, setResetSearchTrigger] = useState(0);
	const [selectInsurer, setSelectInsurer] = useState<KeyValue[]>([]);
	//#endregion

	//#region functions
	function save() {
		closeModal(true);
	}

	function onResetSearch() {
		setDataGridInsurer([]);
		setDataGridBodyshop([]);
		setFormFilters(null);
		setSelectInsurer([]);
		setResetSearchTrigger((prev) => prev + 1);
	}

	function onSearchBodyShops(filters: supervisionAssignmentFilterRequest) {
		setLoad(true);
		setFormFilters(filters);

		if (isNullUndefined(filters)) return;

		if (userIsInsurer()) {
			const request: InsurerFilterRequest = {
				guidCompany: userReducer.currentUser?.guidCompany,
				pageIndex: 1,
				pageSize: PaginationEnum.PageSize15,
			};

			insurerApi.getByInsurer(request).then((res) => {
				filters.guidInsurer = res.data.results[0]?.guid;
				setGuidInsurer(res.data.results[0]?.guid);
				setFormFilters(filters);
			});
		}

		supervisionAssignmentApi
			.getbodyshopinsurerbyfilter(filters)
			.then((res) => {
				const result = res.data?.result;
				setDataGridBodyshop(result.bodyshops?.results);
				setTotalItems(result.bodyshops.totalNumberOfRecords);
				setDataGridInsurer(result.insurers?.results);
			})
			.catch(() => {
				setDataGridBodyshop([]);
				setTotalItems(0);
				setDataGridInsurer([]);
			});

		setLoad(false);
	}
	//#endregion

	return (
		<KogModalSideComponent
			open={open}
			closeModal={() => {
				onResetSearch();
				closeModal(false);
			}}
			id="id-blacklist-modal-scroll"
			titleModalReducer={`${getTranslateByKey("information.registerMyBodyshop")}`}
			title={getTranslateByKey("information.registerMyBodyshop")}
		>
			<S.Container>
				<KOGCollapse
					showBorder={false}
					header={
						<S.BodyBox>
							<S.Title>{getTranslateByKey("information.filters")}</S.Title>
						</S.BodyBox>
					}
					content={
						<SearchBodyshop
							guidCompany={guidCompany}
							OnSearch={onSearchBodyShops}
							isLoad={isLoading}
							OnClear={onResetSearch}
							resetTrigger={resetSearchTrigger}
						/>
					}
					isOpenCollapseinitial={true}
				/>
			</S.Container>

			<S.Container style={{ marginTop: 20 }}>
				<KOGCollapse
					showBorder={false}
					header={
						<S.BodyBox>
							<S.Title>{getTranslateByKey("information.register")}</S.Title>
						</S.BodyBox>
					}
					content={
						<RegisterSupervisorAssignment
							guidCompany={guidCompany}
							guidInsurer={guidInsurer}
							insurers={dataGridInsurer}
							bodyShops={dataGridBodyshop}
							initialFilters={requestFilterForm}
							isAdmin={userIsAdmin()}
							save={save}
							isLoad={isLoading}
							setIsLoad={setLoad}
							selectInsurer={selectInsurer}
							setSelectInsurer={setSelectInsurer}
							resetSearch={onResetSearch}
							intitialTotalItems={totalItems}
						/>
					}
					isOpenCollapseinitial={true}
				/>
			</S.Container>
		</KogModalSideComponent>
	);
}

export default SupervisorBodyshopSidebar;
